<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  created() {
    window.difyChatbotConfig = {
      token: 'QIQ3bT21tZjLKsZY',
      baseUrl: 'https://chatbot.global-dsc.cn',
      containerProps: {
        className: 'my-custom-class',
      },
    }
    const oScript = document.createElement('script');
    oScript.src = 'https://chatbot.global-dsc.cn/embed.min.js';
    oScript.setAttribute("id","QIQ3bT21tZjLKsZY")
    document.body.appendChild(oScript);
  }
}
</script>

<style lang="less">

</style>
